import React from 'react';

/**
 * ManufacturerItem Component
 * Renders a single manufacturer filter item.
 * 
 * Task: P2-004
 */
const ManufacturerItem = ({
  manufacturer,
  isSelected,
  isZeroCount,
  onToggle
}) => {
  const count = manufacturer.count || 0;
  
  return (
    <label
      className={`flex items-center justify-between p-2 rounded-lg cursor-pointer transition-colors ${
        isSelected ? 'bg-blue-50 border border-blue-200' : 
        isZeroCount ? 'opacity-50 bg-slate-50' : 'hover:bg-slate-50'
      }`}
      data-testid={`filter-manufacturer-${manufacturer.name}`}
    >
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(manufacturer.name)}
          className="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
        />
        <span className={`text-sm ${isZeroCount ? 'text-slate-400' : 'text-slate-700'}`}>
          {manufacturer.name}
        </span>
      </div>
      <span className="text-xs text-slate-400 font-mono">({count})</span>
    </label>
  );
};

export default ManufacturerItem;
